<template>
  <div class="container">
    <Card>
      <template #title class="center">WSB | Geohazard Scorecard</template>
      <template #subtitle class="center"
        >Search for an address to receive a scorecard for local Flooding, Landslides, Earthquakes and Sinkholes.
      </template>
      <template #content>
        <slot></slot>
      </template>
      <template #footer>
        <slot name="footer-button"></slot>
        <p class="disclaimer">
          <em
            >WSB is not responsible for implication from data provided by this
            hazard scorecard.</em
          >
        </p>
      </template>
    </Card>
  </div>
</template>

<script>
export default {
  name: "CardView",
  props: {
    toLink: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
}
.disclaimer {
  font-size: 10px;
  margin-top: 5em;
}
</style>